<template>
  <div
    class="labor-template-edit flex w-full justify-start"
    style="flex-direction: column"
  >
    <div ref="crewEditForm" class="py-4" style="margin: 0 1rem">
      <div class="required aisea-text-16-400-black">
        <span
          >必要事項を入力してください。「<label class="required pr-1"
            ><span></span></label
          >」は入力必須項目です。</span
        >
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full required">
          <vs-input
            placeholder="例) 労務基本情報テンプレート"
            class="w-full required"
            label="労務情報テンプレート"
            v-model="localData.label"
            v-validate="'required'"
            name="label"
            data-vv-as="労務情報テンプレート"
            :color="AISEA_COLOR.BLUE"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('label')"
            >{{ errors.first("label") }}</span
          >
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <label class="header-label">労務管理責任者</label>
        <vs-input
          placeholder="例) 海運 一郎"
          class="w-full required"
          v-model="localData.labor_mgmt_rep"
          v-validate="'required'"
          name="labor_mgmt_rep"
          data-vv-as="労務管理責任者"
          :color="AISEA_COLOR.BLUE"
        />
        <span
          class="text-danger text-sm"
          style="margin-left: 0.6rem"
          v-show="errors.has('labor_mgmt_rep')"
          >{{ errors.first("labor_mgmt_rep") }}</span
        >
      </div>

      <div class="w-full justify-start items-start crew-edit-form-row required">
        <label class="header-label">基準労働期間</label>
        <v-select
          placeholder="選択"
          class="w-full"
          v-model="WorkPeriodMonth"
          v-validate="''"
          name="work_period_month"
          :options="workingPeriods"
          :clearable="false"
          @input="inputWorkPeriodMonth"
        />
        <span
          class="text-danger text-sm"
          style="margin-left: 0.6rem"
          v-show="errors.has('work_period_month')"
          >{{ errors.first("work_period_month") }}</span
        >
        <p class="description_label">
          ※休日・補償休日を清算する期間。12カ月以内で設定。
        </p>
      </div>

      <div
        class="
          flex
          w-full
          justify-start
          items-start
          crew-edit-form-row
          required
        "
      >
        <label class="header-label">基準労働期間起算日及び末日</label>
        <div class="flex items-center pb-2">
          <div>
            <v-select
              placeholder="選択"
              style="width: 100px"
              name="work_period_from_month"
              :options="monthSelect"
              v-model="workingPeriodFromMonth"
              v-validate="'required'"
              data-vv-as="起算日（月）"
              :clearable="false"
            />
          </div>
          <span class="m-2">/</span>
          <div>
            <v-select
              placeholder="選択"
              style="width: 100px"
              :disabled="inputMonth()"
              v-model="workingPeriodFromDay"
              v-validate="'required|max:32'"
              name="work_period_from_day"
              data-vv-as="起算日（日）"
              :options="daySelect"
              :clearable="false"
            />
          </div>
          <span class="m-2">〜</span>

          <div>
            <v-select
              placeholder="-"
              style="width: 100px"
              :disabled="true"
              v-model="workingPeriodToMonth"
              name="work_period_to_month"
              data-vv-as="末日（月）"
              :options="[]"
              :clearable="false"
            />
          </div>
          <span class="m-2">/</span>
          <div>
            <v-select
              placeholder="-"
              style="width: 100px"
              :disabled="true"
              v-model="workingPeriodToDay"
              name="work_period_to_day"
              data-vv-as="末日（日）"
              :options="[]"
              :clearable="false"
            />
          </div>
        </div>
        <p class="description_label">※基準労働期間の起算日を選択</p>
        <p class="description_label">※03月01日～04月30日の場合、03/01と入力</p>
        <span
          class="text-danger text-sm"
          style="margin-left: 0.6rem"
          v-show="errors.has('work_period_from_month')"
          >{{ errors.first("work_period_from_month") }}</span
        >
        <span
          class="text-danger text-sm"
          style="margin-left: 0.6rem"
          v-show="errors.has('work_period_from_day')"
          >{{ errors.first("work_period_from_day") }}</span
        >
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full required">
          <label class="header-label">時間外労使協定の有無</label>
          <v-select
            placeholder="選択"
            class="w-full"
            v-model="overtimeLaborAgrmt"
            v-validate="'required'"
            name="overtime_labor_agrmt"
            data-vv-as="時間外労使協定の有無"
            :options="boolSelect()"
            :clearable="false"
            @input="inputOvertimeLaborAgrmt"
          >
          </v-select>
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('overtime_labor_agrmt')"
            >{{ errors.first("overtime_labor_agrmt") }}</span
          >
          <p class="description_label">
            ※時間外労働を認める旨の協定。事前に組合等と書面で締結し、所轄地方運輸局に提出しているもの（労働協約内に含まれることもあり）
          </p>
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full required">
          <label class="header-label">補償休日労働協定の有無</label>
          <v-select
            placeholder="選択"
            class="w-full"
            v-model="compensatoryTimeOffLaborAgrmt"
            v-validate="'required'"
            name="compensatory_time_off_labor_agrmt"
            data-vv-as="補償休日労働協定の有無"
            :options="boolSelect()"
            :clearable="false"
            @input="inputCompensatoryTimeOffLaborAgrmt"
          >
          </v-select>
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('compensatory_time_off_labor_agrmt')"
            >{{ errors.first("compensatory_time_off_labor_agrmt") }}</span
          >
          <p class="description_label">
            ※補償休日であっても労働をさせることができる旨の協定（労働協約内に含まれることもあり）
          </p>
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full required">
          <label class="header-label">休息時間分割回数協定の有無</label>
          <v-select
            placeholder="選択"
            class="w-full"
            v-model="breakLaborAgrmt"
            v-validate="'required'"
            name="break_labor_agrmt"
            data-vv-as="休息時間分割回数協定の有無"
            :options="boolSelect()"
            :clearable="false"
            @input="inputBreakLaborAgrmt"
          >
          </v-select>
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('break_labor_agrmt')"
            >{{ errors.first("break_labor_agrmt") }}</span
          >
          <p class="description_label">
            ※休息時間を3分割以上、もしくは分割時の長い方の休息時間を6時間未満とすることができる旨の協定（労働協約内に含まれることもあり）
          </p>
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full required">
          <label class="header-label">休日日数の定めの有無</label>
          <v-select
            placeholder="選択"
            class="w-full"
            v-model="mandatoryDayOff"
            v-validate="'required'"
            name="mandatory_day_off"
            data-vv-as="休日日数の定めの有無"
            :clearable="false"
            :options="boolSelect()"
            @input="inputMandatoryDayOff"
          >
          </v-select>
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('mandatory_day_off')"
            >{{ errors.first("mandatory_day_off") }}</span
          >
          <p class="description_label">
            ※施行規則第42条の２第３項に基づく休日の日数の定めの有無を選択
          </p>
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div
          class="w-full required"
          :class="{ 'disabled-area': !localData.mandatory_day_off }"
        >
          <label class="header-label">休日日数を定めている場合の日数</label>
          <vs-input
            :disabled="!localData.mandatory_day_off"
            placeholder="120"
            class="w-full"
            v-model="localData.num_of_mandatory_day_off"
            v-validate="'numeric|max_value:365|min_value:1'"
            name="num_of_mandatory_day_off"
            data-vv-as="休日日数を定めている場合の日数"
            :color="AISEA_COLOR.BLUE"
            :clearable="false"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('num_of_mandatory_day_off')"
            >{{ errors.first("num_of_mandatory_day_off") }}</span
          >

          <p class="description_label">
            ※上記で「有」を選択した場合に、労働協約、就業規則等において定められている、基準労働期間内に与える休日の日数を記載
          </p>
        </div>
      </div>

      <div class="w-full justify-start items-start crew-edit-form-row">
        <div class="required">
          <label class="header-label">有給休暇の必要日数</label>
          <vs-input
            placeholder="例)20"
            class="w-full"
            v-model="localData.num_of_mandatory_paid_time_off"
            v-validate="'required|numeric|max_value:365|min_value:1'"
            name="num_of_mandatory_paid_time_off"
            data-vv-as="有給休暇の必要日数"
            :color="AISEA_COLOR.BLUE"
            :clearable="false"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('num_of_mandatory_paid_time_off')"
            >{{ errors.first("num_of_mandatory_paid_time_off") }}</span
          >
        </div>
      </div>

      <div class="flex w-full justify-start items-start crew-edit-form-row">
        <div class="w-full required">
          <label class="header-label">法第72条特例への該当有無</label>
          <v-select
            placeholder="選択"
            class="w-full"
            v-model="marinersLawArt72Applicable"
            v-validate="'required|max:32'"
            name="mariners_law_art_72_applicable"
            data-vv-as="法第72条特例への該当有無"
            :clearable="false"
            :options="boolSelect()"
            @input="inputMarinersLawArt72Applicable"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('mariners_law_art_72_applicable')"
            >{{ errors.first("mariners_law_art_72_applicable") }}</span
          >
        </div>
      </div>

      <div
        class="
          flex
          w-full
          justify-start
          items-start
          crew-edit-form-row
          required
        "
        :class="{ 'disabled-area': !localData.mariners_law_art_72_applicable }"
      >
        <div class="w-full">
          <label class="header-label">1日あたり労働時間上限</label>
          <v-select
            placeholder="選択"
            class="w-full"
            :disabled="!localData.mariners_law_art_72_applicable"
            v-model="maxWorkHourPerDay"
            v-validate="''"
            name="max_work_hour_per_day"
            data-vv-as="1日あたり労働時間上限"
            :options="TimeSelect"
            :clearable="false"
            @input="() => inputMaxWorkHourPerDay()"
          />
          <span
            class="text-danger text-sm"
            style="margin-left: 0.6rem"
            v-show="errors.has('max_work_hour_per_day')"
            >{{ errors.first("max_work_hour_per_day") }}</span
          >
          <span class="description_label"
            >※時間外労働が認められていたとしても、1日14時間を超えてはならない</span
          >
        </div>
      </div>

      <div class="crew-edit-form-row">
        <div class="required">
          <label class="header-label">労務情報の基本テンプレート適用</label>
        </div>
        <div class="flex items-center m-2">
          <vs-radio
            v-model="localData.is_default"
            class="mr-4"
            vs-name="is_default"
            :vs-value="true"
            :color="AISEA_COLOR.BLUE"
          >
            <span class="font-normal">はい</span>
          </vs-radio>
          <vs-radio
            v-model="localData.is_default"
            vs-name="is_default"
            :vs-value="false"
            :color="AISEA_COLOR.BLUE"
          >
            <span class="font-normal">いいえ</span>
          </vs-radio>
        </div>
        <span
          class="text-danger text-sm"
          style="margin-left: 0.6rem"
          v-show="errors.has('is_default')"
          >{{ errors.first("is_default") }}</span
        >
        <p class="description_label">
          ※基本テンプレートとして登録すると、船員を新規登録する際にデフォルトのテンプレートとして表示されます。「いいえ」を選択した場合は、各船員の「労務情報」タブから船員個別に労務情報を適用することができます。
        </p>
      </div>
    </div>

    <vs-divider style="margin: 0" />

    <div class="flex w-full justify-end items-center">
      <div style="margin: 0.8rem">
        <vs-button
          type="border"
          style="width: 6rem; padding: 0.4rem"
          @click="onCancel"
          :color="AISEA_COLOR.GRAY"
          >キャンセル</vs-button
        >
      </div>
      <div style="margin: 0.8rem">
        <vs-button
          :disabled="!validate"
          :color="AISEA_COLOR.BLUE"
          style="width: 6rem; padding: 0.4rem"
          @click="onSubmit"
          >保存</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import vSelect from "vue-select";
import moment from "moment";
import _ from "lodash";

import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions, mapMutations } = createNamespacedHelpers("crewLaborTemplate");
// テンプレートの起算日を計算するための基準年
const TEMPLATE_YEAR = 2022;



export default {
  mixins: [ColorMixin],
  name: "CrewLaborTemplateEdit",
  components: {
    vSelect,
  },
  props: {
    inputParam: Object,
    activeSidebarCrew: Boolean,
  },
  data () {
    return {
      localData: {},
      workingPeriod: null,
      WorkPeriodMonth: "",
      workingPeriodFromMonth: "",
      workingPeriodFromDay: "",
      workingPeriodToMonth: "",
      workingPeriodToDay: "",
      maxWorkHourPerDay: null,
      overtimeLaborAgrmt: null,
      compensatoryTimeOffLaborAgrmt: null,
      breakLaborAgrmt: null,
      mandatoryDayOff: null,
      marinersLawArt72Applicable: null,
    };
  },
  computed: {
    ...mapState(["template"]),
    validate () {
      const checkMandatoryDayOff = this.validateMandatoryDayOff()
      const checkMaxWorkHourPerDay = this.validateMaxWorkHourPerDay()

      if (this.errors.any() || !checkMandatoryDayOff || !checkMaxWorkHourPerDay) {
        return false;
      }

      if (!this.isValidRequired()) return false;  // 必須項目が入力されているかチェック

      return true;
    },
    monthSelect () {
      return Array.from({ length: 12 }, (_, index) => {
        return {
          label: (`0${index + 1}`).slice(-2),
          value: index + 1
        }
      })
    },
    daySelect () {
      if (!this.workingPeriodFromMonth.value) return []
      const endOfMonthDay = parseInt(moment(`${this.workingPeriodFromMonth.label}01`, "MMDD").endOf("month").format("D"))

      return Array.from({ length: endOfMonthDay }, (_, index) => {
        return {
          label: (`0${index + 1}`).slice(-2),
          value: index + 1
        }
      })
    },
    TimeSelect () {
      return Array.from({ length: 14 }, (_, index) => {
        return {
          label: `${index + 1}時間`,
          value: index + 1
        }
      });
    },
    workingPeriods () {
      return Array.from({ length: 12 }, (_, index) => {
        return {
          label: `${index + 1}ヶ月`,
          value: index + 1
        }
      });
    },
  },
  watch: {
    activeSidebarCrew (val) {
      if (!val) return;
      this.initLocalData();
      this.$validator.reset();
    },

    mandatoryDayOff (val) {
      // 休日日数の定めの有無が無の場合は空にする
      if (val === "無") this.localData.num_of_mandatory_day_off = "";
    },

    workingPeriodFromMonth (_) {
      this.calcWorkPeriodToMonth();
    },
    workingPeriodFromDay (_) {
      this.calcWorkPeriodToMonth();
    },

    WorkPeriodMonth (_) {
      this.calcWorkPeriodToMonth();
    },

  },
  methods: {
    ...mapMutations(["SET_TEMPLATE"]),
    ...mapActions(["fetchTemplateList", "fetchTemplate", "addTemplate", "updateTemplate", "selectTemplate"]),

    async calcWorkPeriodToMonth () {
      if (!this.WorkPeriodMonth.value || !this.workingPeriodFromMonth.value || !this.workingPeriodFromDay.value) return;

      // 起算月を変更した際、選択可能な日にちよりも大きい起算日の場合は、選択可能な最大の日に変更
      const maxDayValue = Math.max(...this.daySelect.map((dS) => dS.value));
      this.workingPeriodFromDay = maxDayValue < this.workingPeriodFromDay.value
        ? this.daySelect.find((dS) => dS.value === maxDayValue)
        : this.workingPeriodFromDay;

      const fromMoment = moment({
        years: TEMPLATE_YEAR,
        months: this.workingPeriodFromMonth.value - 1,
        days: this.workingPeriodFromDay.value,
      });

      let toMoment = moment(fromMoment).add(this.WorkPeriodMonth.value, "months");
      // 起算日が末日よりもおおきい場合は、末日をデクリメントする
      if (fromMoment.date() <= toMoment.date()) {
        toMoment.subtract(1, "days");
      }

      // 末月を変更
      this.workingPeriodToMonth = {
        label: toMoment.format("MM"),
        value: toMoment.month() + 1,
      };

      // 末日を変更
      this.workingPeriodToDay = {
        label: toMoment.format("DD"),
        value: toMoment.date(),
      };

      this.setWorkPeriodRange();

    },

    async setWorkPeriodRange () {
      this.localData.work_period_from_month = this.workingPeriodFromMonth.value;
      this.localData.work_period_from_day = this.workingPeriodFromDay.value;
      this.localData.work_period_to_month = this.workingPeriodToMonth.value;
      this.localData.work_period_to_day = this.workingPeriodToDay.value;
    },

    async initLocalData () {
      if (!this.inputParam.id) {
        this.localData = {};
        return;
      }

      await this.fetchTemplate(this.inputParam.id);

      if (!this.template) {
        this.localData = {};
        return;
      }

      this.localData = _.cloneDeep(this.template);
      this.setLocalDataParam();

    },

    setLocalDataParam () {
      this.overtimeLaborAgrmt = this.localData.overtime_labor_agrmt ? "有" : "無"
      this.compensatoryTimeOffLaborAgrmt = this.localData.compensatory_time_off_labor_agrmt ? "有" : "無"
      this.breakLaborAgrmt = this.localData.break_labor_agrmt ? "有" : "無"
      this.mandatoryDayOff = this.localData.mandatory_day_off ? "有" : "無"
      this.marinersLawArt72Applicable = this.localData.mariners_law_art_72_applicable ? "有" : "無"

      this.WorkPeriodMonth = {
        label: `${this.localData.work_period_month}ヶ月`,
        value: this.localData.work_period_month
      };

      this.maxWorkHourPerDay = {
        label: this.localData.max_work_hour_per_day ? `${this.localData.max_work_hour_per_day}時間` : null,
        value: this.localData.max_work_hour_per_day
      }

      const fromMoment = moment({
        years: TEMPLATE_YEAR,
        months: this.localData.work_period_from_month - 1,
        days: this.localData.work_period_from_day,
      });
      this.workingPeriodFromMonth = {
        label: fromMoment.format("MM"),
        value: fromMoment.month() + 1,
      };
      this.workingPeriodFromDay = {
        label: fromMoment.format("DD"),
        value: fromMoment.date(),
      };

    },

    validateMandatoryDayOff () {
      if (!this.localData.mandatory_day_off) return true;
      return this.localData.num_of_mandatory_day_off
    },

    validateMaxWorkHourPerDay () {
      if (!this.localData.mariners_law_art_72_applicable) return true;
      return this.localData.max_work_hour_per_day
    },

    onCancel () {
      this.localData = {};
      this.$nextTick(() => {
        this.$emit('close');
      });
    },
    async update () {
      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });
        const payload = {
          id: this.inputParam.id,
          params: this.localData
        }
        await this.updateTemplate(payload);

        this.$vs.notify({
          title: `労務基本情報更新`,
          text: `${this.localData.label}を更新しました`,
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        const msg = `${this.localData.label}の更新に失敗しました。時間を空けて再度試みてください。`
        this.$vs.notify({
          title: `労務基本情報更新`,
          text: msg,
          color: "danger",
          iconPack: "feather",
          icon: "icon-check"
        });

      }
    },
    async create () {
      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE, });
        const res = await this.addTemplate(this.localData);
        this.$vs.notify({
          title: `労務基本情報登録`,
          text: `${this.localData.label}を登録しました`,
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        });
        this.$vs.loading.close();
        return res;
      } catch (error) {
        const msg = `${this.localData.label}の登録に失敗しました。時間を空けて再度試みてください。`
        this.$vs.notify({
          title: `労務基本情報登録`,
          text: msg,
          color: "danger",
          iconPack: "feather",
          icon: "icon-check"
        });
      }
    },
    async onSubmit () {
      let checkValidate = await this.$validator.validateAll();
      if (!checkValidate) return;

      if (this.inputParam.id) {
        await this.update();
      } else {
        const res = await this.create();
        this.localData.id = res.data.id;
      }

      if (this.localData.is_default) {
        await this.selectTemplate(this.localData.id);
      }

      await this.fetchTemplate(this.localData.id);
      this.localData = {};
      this.$emit('close');

      await this.fetchTemplateList();

    },
    boolSelect () {
      return ["有", "無"]
    },
    selectedBoolItem (data) {
      const item = this.boolSelect();
      return item.find(item => item.value === data)
    },

    inputMonth () {
      if (!this.workingPeriodFromMonth.value) return true;
      return this.workingPeriodFromMonth.value < 1 || this.workingPeriodFromMonth.value > 12;
    },
    inputWorkPeriodMonth () {
      this.localData.work_period_month = this.WorkPeriodMonth.value
    },
    inputOvertimeLaborAgrmt () {
      this.localData.overtime_labor_agrmt = this.overtimeLaborAgrmt === "有";
    },
    inputCompensatoryTimeOffLaborAgrmt () {
      this.localData.compensatory_time_off_labor_agrmt = this.compensatoryTimeOffLaborAgrmt === "有";
    },
    inputBreakLaborAgrmt () {
      this.localData.break_labor_agrmt = this.breakLaborAgrmt === "有";
    },
    inputMandatoryDayOff () {
      this.localData.mandatory_day_off = this.mandatoryDayOff === "有";
    },
    inputMarinersLawArt72Applicable () {
      this.localData.mariners_law_art_72_applicable = this.marinersLawArt72Applicable === "有";
    },
    inputMaxWorkHourPerDay () {
      this.localData.max_work_hour_per_day = this.maxWorkHourPerDay.value;
    },
    isTrueOrFalse (value) {
      return value === true || value === false;
    },
    // 必須入力チェック
    isValidRequired () {
      return this.localData.label // 労務情報テンプレート
        && this.localData.labor_mgmt_rep // 労務管理責任者
        && this.localData.work_period_month // 基準労働期間
        && this.localData.work_period_from_month // 起算月
        && this.localData.work_period_from_day // 起算日
        && this.localData.work_period_to_month // 末月
        && this.localData.work_period_to_day // 末日
        && this.isTrueOrFalse(this.localData.overtime_labor_agrmt)  // 時間外労使協定の有無
        && this.isTrueOrFalse(this.localData.compensatory_time_off_labor_agrmt)  // 補償休日労働協定の有無
        && this.isTrueOrFalse(this.localData.break_labor_agrmt)  // 休息時間分割回数協定の有無
        && this.isTrueOrFalse(this.localData.mandatory_day_off)  // 休日日数の定めの有無
        && (this.localData.mandatory_day_off === false || (this.localData.mandatory_day_off && 0 < Number(this.localData.num_of_mandatory_day_off) && Number(this.localData.num_of_mandatory_day_off < 366)))  // 休日日数を定めている場合の日数
        && 0 < Number(this.localData.num_of_mandatory_paid_time_off) // 有給休暇の必要日数
        && this.isTrueOrFalse(this.localData.mariners_law_art_72_applicable) // 法第72条特例への該当有無
        && (this.localData.mariners_law_art_72_applicable === false || (this.localData.mariners_law_art_72_applicable && this.localData.max_work_hour_per_day)) // 1日あたり労働時間上限
        && this.isTrueOrFalse(this.localData.is_default);  // 労務情報の基本テンプレート適用
    },
  },
  created () {
    this.initLocalData();
  },

  beforeDestroy () {
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.labor-template-edit {
  .disabled-area {
    color: $aisea-mouse-gray;
  }
  .header-label {
    font-size: 0.8rem;
  }
  .required label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger), 1);
    }
  }

  .description_label {
    font-size: 0.8rem;
  }

  .vs-inputx {
    color: $aisea-dark-gray !important;
    font-family: $aisea-font-family;
    font-size: 16px !important;
    font-weight: 400;
  }
  .vs-input--placeholder {
    color: $aisea-slightly-gray !important;
  }

  .v-select {
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    input {
      height: 2rem;
    }
  }

  .crew-edit-form-row {
    flex-direction: column;
    margin: 24px 0;
    padding-right: 8px;

    label {
      font-family: $aisea-font-family;
      font-size: 14px;
      font-weight: 600;
    }
  }

  .vs__search::placeholder {
    color: #d3d3d3;
  }

  .vdp-datepicker input {
    padding-left: 2.4rem;
  }

  .vs-collapse-item--header {
    padding: 0;
  }
}
</style>
